export enum DocumentationCapability {
  VIEW = 'VIEW',
  DOWNLOAD = 'DOWNLOAD',
  UPLOAD = 'UPLOAD',
  EDIT_REQUIRED_DOCUMENTS = 'EDIT_REQUIRED_DOCUMENTS',
  EDIT_DOCUMENT_STATUS = 'EDIT_DOCUMENT_STATUS',
  LENDER_SYNC = 'LENDER_SYNC',
  LENDER_SEND = 'LENDER_SEND',
}
